import { useState } from "react"

import useT from "utils/hooks/useT"
import EditSheets from "../EditSheets"
import UploadDropzone from "../UploadDropzone"
import UploadButton from "../UploadButton"
import { Popup, IntegrationResultMessage } from "components"

export default function AutomaticIntegrationTab() {
    const { t } = useT("common")
    const [filesAutomatic, setFilesAutomatic] = useState([])
    const [resultMessage, setResultMessage] = useState(null)
    return (
        <div className="integration-tab">
            {resultMessage && (
                <Popup
                    onCancel={() => setResultMessage(null)}
                    title={resultMessage.aborted ? t("uploadAborted") : t("uploadComplete")}
                >
                    <IntegrationResultMessage resultMessage={resultMessage} setResultMessage={setResultMessage} />
                </Popup>
            )}
            <p>{t("automaticSheetConfiguration")}</p>
            <div className="automatic-sheet-container">
                <EditSheets isAutomatic />
            </div>
            <p>{t("fileUpload")}</p>
            <UploadDropzone files={filesAutomatic} onSubmit={setFilesAutomatic} />
            <UploadButton
                route="/upload/raw-data"
                files={filesAutomatic}
                setFiles={setFilesAutomatic}
                setResultMessage={setResultMessage}
            />
        </div>
    )
}
